import React from 'react';
import { MultiSelectComponents } from '@usealloy/component-library';
import type { OptionProps } from '@usealloy/component-library';
import type { SaveToAWorkflowOptionType } from './types';
import { StyledText } from './styles';

interface SaveToAWorkflowOptionProps extends OptionProps<SaveToAWorkflowOptionType, false> { }
export default function SaveToAWorkflowOption(props: SaveToAWorkflowOptionProps) {
  const {
    data: {
      label,
    },
  } = props;

  return (
    <MultiSelectComponents.Option {...props}>
      <StyledText>{label}</StyledText>
    </MultiSelectComponents.Option>
  );
}
